import { createContext } from 'react'

const IconsContext = createContext(new Map())

export default IconsContext
